import React from 'react';
import { LoaderRow } from '../../atoms/layout/LoaderRow';
import { SubmissionEvaluationResult } from '../../../../adminv3/types/courseExams';
import './submissionEvaluationResult.module.scss';
import { SubmittedEvaluationBlockPane } from './SubmittedEvaluationBlock';
import { SubmittedReviewFields } from './SubmittedReviewFields';
import {
  SubmissionEvaluationResultPassMessage,
  SubmissionEvaluationResultFailMessage,
} from './SubmissionEvaluationResultMessage';
import { ExamPracticalSectionSubmissionShowView } from '../../../types/exam_sections';

export type Props = {
  submission: ExamPracticalSectionSubmissionShowView;
  result: SubmissionEvaluationResult;
  loading: boolean;
};

export const SubmissionEvaluationResultPane = ({ submission, result, loading }: Props) => {
  const submittedEvaluationBlocks = result.submitted_evaluation_blocks;
  const submittedReviewFields = result.submitted_review_fields;
  const submittedScore = submission.score;

  return (
    <div styleName="wrapper">
      {submission.passed ? (
        <SubmissionEvaluationResultPassMessage submittedScore={submittedScore} />
      ) : (
        <SubmissionEvaluationResultFailMessage
          submissionSectionID={submission.section.id}
          submittedScore={submittedScore}
        />
      )}
      <div styleName="evaluation-result-wrapper">
        <div data-wrapper="evaluation-blocks-wrapper">
          {submittedEvaluationBlocks.map((block) => (
            <SubmittedEvaluationBlockPane
              key={block.id}
              passed={submission.passed}
              submittedEvaluationBlock={block}
              loading={loading}
            />
          ))}
          {loading && <LoaderRow />}
        </div>
        <div>
          <SubmittedReviewFields
            submittedReviewFields={submittedReviewFields}
            review_completed_at={submission.review_completed_at}
          />
        </div>
      </div>
    </div>
  );
};
